import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';


export interface ConfirmCancelDialogData {
  title: string;
  entityName: string; 
  message: string;
}

@Component({
  selector: 'app-confirm-cancel-dialog',
  templateUrl: './drake-confirm-cancel-dialog.component.html',
  styleUrls: ['./drake-confirm-cancel-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
      MatButtonModule,
      TranslocoModule 
  ]
})
export class ConfirmCancelDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmCancelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmCancelDialogData
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
